import { useReduxState } from 'hooks';
import { FormGroup } from 'components/common/form';
import { useState } from 'react';
import { TextInput } from 'components/common/form/common';

interface Props {
  onPasswordChange: (value: string) => void;
  onPasswordErrorChange: (value: string) => void;
  passwordError: string | undefined;
}

const ReaderCompletionFormSignature = ({
  onPasswordChange,
  onPasswordErrorChange,
  passwordError
}: Props) => {
  const {
    language,
    messages,
    serverConfig: { courseCompletionElectronicSignature: data, userUseName },
    theme,
    user
  } = useReduxState();

  const handlePasswordChange: React.ChangeEventHandler<HTMLInputElement> = (
    ev
  ) => {
    const { value } = ev.target;

    onPasswordErrorChange(
      !value || !value.trim() ? messages.commonFieldRequired : undefined
    );

    onPasswordChange(value);
  };

  if (!user) return null;

  let translatedTexts = {};
  try {
    translatedTexts = JSON.parse(data.translatedTexts || '{}');
  } catch {}

  const signatureText = translatedTexts[language] || data.defaultText;

  return (
    <div className="signature">
      <div className="title">{messages.completionElectronicSignature}</div>

      {signatureText ? <p className="text">{signatureText}</p> : null}

      <div className="attributes">
        <div className="attribute">
          <div className="label">{messages.commonEmail}</div>
          <div className="value">{user.email}</div>
        </div>

        {userUseName && user.firstName && user.lastName ? (
          <div className="attribute">
            <div className="label">{messages.commonName}</div>
            <div className="value">{`${user.firstName} ${user.lastName}`}</div>
          </div>
        ) : (
          <div className="attribute">
            <div className="label">{messages.commonUsername}</div>
            <div className="value">{user.username}</div>
          </div>
        )}
      </div>

      {['local', 'local-totp'].includes(user?.authenticatorType) ? (
        <div className="password">
          <FormGroup label={messages.commonPassword} maxWidth="300px">
            <TextInput
              error={passwordError}
              type="password"
              onChange={handlePasswordChange}
            />
            {passwordError ? (
              <div className="error">{passwordError}</div>
            ) : null}
          </FormGroup>
        </div>
      ) : null}

      <style jsx>{`
        .signature {
          background-color: ${theme.lightGrey};
          border-radius: ${theme.cardBorderRadius};
          padding: 15px;
        }
        .title {
          color: ${theme.textColor};
          font-weight: 700;
          margin: 0 0 10px;
        }
        .text {
          margin: 0 0 10px;
        }
        .attributes {
          display: table;
        }
        .attribute {
          display: table-row;
        }
        .label {
          display: table-cell;
          padding: 2px 25px 2px 0;
        }
        .password {
          margin-top: 15px;
        }
        .value {
          display: table-cell;
          padding: 2px 0;
        }
        .error {
          font-size: 1.3rem;
          font-weight: 400;
          color: ${theme.dangerColor};
          padding: 3px;
        }
      `}</style>
    </div>
  );
};

export default ReaderCompletionFormSignature;
